/**
 * @file index.tsx
 *
 * @fileoverview Joins a list of strings together.
 */

import React, { FunctionComponent } from 'react';

interface StringJoinerProps {
  items: string[];
  separator?: string;
}

export const StringJoiner: FunctionComponent<StringJoinerProps> = ({
  items,
  separator = ',',
}) => <React.Fragment>{items.join(`${separator} `)}</React.Fragment>;

export default StringJoiner;
